import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { SideNavId } from "../../../enums/StringLiterals/sideNavId";
import { SideNavLabel } from "../../../enums/StringLiterals/sideNavLabel";
import SftpSummaryContent from "./components/sftpSummaryContent";
import { useSftpSummaryStats } from "./hooks/useSftpSummaryStats";

interface SftpSummaryProps {
  onClose: () => void;
  onSave: () => void;
}

const tabs = [
  {
    id: SideNavId.SFTP_SUMMARY_RESPONSE_STATUS,
    label: SideNavLabel.SFTP_SUMMARY_RESPONSE_STATUS,
  },
  {
    id: SideNavId.SFTP_SUMMARY_TEXT_NOTES,
    label: SideNavLabel.SFTP_SUMMARY_TEXT_NOTES,
  },
];

const SftpSummary = (props: SftpSummaryProps) => {
  const [selectedTab, setSelectedTab] = useState<string>(
    SideNavId.SFTP_SUMMARY_RESPONSE_STATUS,
  );

  const {
    tableData,
    loading,
    showInlineLoader,
    error,
    totalCount,
    setEndIndex,
  } = useSftpSummaryStats({
    pageSize: 40,
  });

  return (
    <Modal
      dialogId={ModalId.SFTP_SUMMARY_MODAL}
      title="SFTP Summary"
      onClose={props.onClose}
      onSave={props.onSave}
      saveButtonText="Close"
      cancelText="Cancel"
      heightPercentage={70}
      hideFooter={true}
    >
      <div className="flex h-full flex-col">
        {/* Top Navigation Tabs */}
        <div className="flex border-b border-gray-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setSelectedTab(tab.id)}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                tab.id === selectedTab
                  ? "border-b-2 border-blue-500 text-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        {/* Table Content */}
        <div className="content--container flex h-full flex-1 flex-col overflow-y-auto bg-white p-1">
          <SftpSummaryContent
            selectedTab={selectedTab}
            tableData={tableData}
            loading={loading}
            showInlineLoader={showInlineLoader}
            error={error}
            totalCount={totalCount}
            setEndIndex={setEndIndex}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SftpSummary;
